export const students = [
  {
    name: "Elsa",
    type: "dev",
    top: [2, 6, 5],
    entreprise: {
      arrivee: "09h35",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 4,
          depart: "maison",
          arrivee: "Colonel Fabien",
        },
        {
          type: "metro",
          ligne: "2",
          duree: 12,
          depart: "Colonel Fabien",
          arrivee: "Alexandre Dumas",
        },
        {
          type: "pied",
          ligne: "",
          duree: 10,
          depart: "Alexandre Dumas",
          arrivee: "entreprise",
        },
      ],
    },
    ecole: {
      arrivee: "09h10",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 3,
          depart: "maison",
          arrivee: "Bolivar",
        },
        {
          type: "metro",
          ligne: "7bis",
          duree: 12,
          depart: "Bolivar",
          arrivee: "Place des Fêtes",
        },
        {
          type: "metro",
          ligne: "11",
          duree: 5,
          depart: "Place des Fêtes",
          arrivee: "Porte des Lilas",
        },
        {
          type: "pied",
          ligne: "",
          duree: 2,
          depart: "Porte des Lilas",
          arrivee: "ecole",
        },
      ],
    },
  },
  {
    name: "Tara",
    type: "des",
    top: [11, 1, 14],
    entreprise: {
      arrivee: "09h30",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 10,
          depart: "maison",
          arrivee: "République",
        },
        {
          type: "metro",
          ligne: "9",
          duree: 4,
          depart: "République",
          arrivee: "Grands Boulevards",
        },
        {
          type: "pied",
          ligne: "",
          duree: 4,
          depart: "Grands Boulevards",
          arrivee: "entreprise",
        },
      ],
    },
    ecole: {
      arrivee: "09h10",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 8,
          depart: "maison",
          arrivee: "Goncourt",
        },
        {
          type: "metro",
          ligne: "11",
          duree: 7,
          depart: "Goncourt",
          arrivee: "Porte des Lilas",
        },
        {
          type: "pied",
          ligne: "",
          duree: 2,
          depart: "Porte des Lilas",
          arrivee: "ecole",
        },
      ],
    },
  },
  {
    name: "Evan",
    type: "dev",
    top: [14, 9, 4],
    entreprise: {
      arrivee: "09h00",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 10,
          depart: "maison",
          arrivee: "Mairie des Lilas",
        },
        {
          type: "metro",
          ligne: "11",
          duree: 15,
          depart: "Mairie des Lilas",
          arrivee: "Rambuteau",
        },
        {
          type: "pied",
          ligne: "",
          duree: 1,
          depart: "Rambuteau",
          arrivee: "entreprise",
        },
      ],
    },
    ecole: {
      arrivee: "08h50",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 1,
          depart: "maison",
          arrivee: "Les Malassis",
        },
        {
          type: "bus",
          ligne: "115",
          duree: 20,
          depart: "Les Malassis",
          arrivee: "Porte des Lilas",
        },
        {
          type: "pied",
          ligne: "",
          duree: 2,
          depart: "Porte des Lilas",
          arrivee: "ecole",
        },
      ],
    },
  },
  {
    name: "Némo",
    type: "des",
    top: [14, 6, 2],
    entreprise: {
      arrivee: "08h55",
      trajet: [
        {
          type: "teletravail",
          ligne: "",
          duree: 1,
          depart: "maison",
          arrivee: "maison",
        },
      ],
    },
    ecole: {
      arrivee: "08h50",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 20,
          depart: "maison",
          arrivee: "Porte de Vincennes",
        },
        {
          type: "tram",
          ligne: "T3b",
          duree: 12,
          depart: "Porte de Vincennes",
          arrivee: "Porte des Lilas",
        },
        {
          type: "pied",
          ligne: "",
          duree: 2,
          depart: "Porte des Lilas",
          arrivee: "ecole",
        },
      ],
    },
  },
  {
    name: "Margot",
    type: "des",
    top: [14, 1, 10],
    entreprise: {
      arrivee: "10h00",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 1,
          depart: "maison",
          arrivee: "La Motte-Picquet - Grenelle",
        },
        {
          type: "metro",
          ligne: "10",
          duree: 12,
          depart: "La Motte-Picquet - Grenelle",
          arrivee: "Boulogne Jean Jaurès",
        },
        {
          type: "pied",
          ligne: "",
          duree: 1,
          depart: "Boulogne Jean Jaurès",
          arrivee: "entreprise",
        },
      ],
    },
    ecole: {
      arrivee: "09h00",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 1,
          depart: "maison",
          arrivee: "La Motte-Picquet - Grenelle",
        },
        {
          type: "metro",
          ligne: "8",
          duree: 15,
          depart: "La Motte-Picquet - Grenelle",
          arrivee: "République",
        },
        {
          type: "metro",
          ligne: "11",
          duree: 8,
          depart: "République",
          arrivee: "Porte des Lilas",
        },
        {
          type: "pied",
          ligne: "",
          duree: 2,
          depart: "Porte des Lilas",
          arrivee: "ecole",
        },
      ],
    },
  },
  {
    name: "Léa",
    type: "des",
    top: [14, 7, 1],
    entreprise: {
      arrivee: "09h30",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 7,
          depart: "maison",
          arrivee: "Place Monge",
        },
        {
          type: "metro",
          ligne: "7",
          duree: 9,
          depart: "Place Monge",
          arrivee: "Palais-Royal - Musée du Louvre",
        },
        {
          type: "metro",
          ligne: "1",
          duree: 9,
          depart: "Palais-Royal - Musée du Louvre",
          arrivee: "Porte Maillot",
        },
        {
          type: "pied",
          ligne: "",
          duree: 7,
          depart: "Porte Maillot",
          arrivee: "entreprise",
        },
      ],
    },
    ecole: {
      arrivee: "09h05",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 7,
          depart: "maison",
          arrivee: "Place Monge",
        },
        {
          type: "metro",
          ligne: "7",
          duree: 6,
          depart: "Place Monge",
          arrivee: "Châtelet",
        },
        {
          type: "metro",
          ligne: "11",
          duree: 14,
          depart: "Châtelet",
          arrivee: "Porte des Lilas",
        },
        {
          type: "pied",
          ligne: "",
          duree: 2,
          depart: "Porte des Lilas",
          arrivee: "ecole",
        },
      ],
    },
  },
  {
    name: "Elie",
    type: "des",
    top: [14, 6, 11],
    entreprise: {
      arrivee: "09h15",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 5,
          depart: "maison",
          arrivee: "Jourdain",
        },
        {
          type: "metro",
          ligne: "11",
          duree: 10,
          depart: "Jourdain",
          arrivee: "Châtelet",
        },
        {
          type: "metro",
          ligne: "14",
          duree: 8,
          depart: "Châtelet",
          arrivee: "Bibliothèque François Mitterrand",
        },
        {
          type: "pied",
          ligne: "",
          duree: 9,
          depart: "Bibliothèque François Mitterrand",
          arrivee: "entreprise",
        },
      ],
    },
    ecole: {
      arrivee: "09h05",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 5,
          depart: "maison",
          arrivee: "Jourdain",
        },
        {
          type: "metro",
          ligne: "11",
          duree: 3,
          depart: "Jourdain",
          arrivee: "Porte des Lilas",
        },
        {
          type: "pied",
          ligne: "",
          duree: 2,
          depart: "Porte des Lilas",
          arrivee: "ecole",
        },
      ],
    },
  },
  {
    name: "Antoine O.",
    type: "dev",
    top: [2, 14, 13],
    entreprise: {
      arrivee: "10h00",
      trajet: [
        {
          type: "trottinette",
          ligne: "",
          duree: 10,
          depart: "maison",
          arrivee: "entreprise",
        },
      ],
    },
    ecole: {
      arrivee: "09h20",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 3,
          depart: "maison",
          arrivee: "Rome",
        },
        {
          type: "metro",
          ligne: "2",
          duree: 15,
          depart: "Rome",
          arrivee: "Belleville",
        },
        {
          type: "metro",
          ligne: "11",
          duree: 6,
          depart: "Belleville",
          arrivee: "Porte des Lilas",
        },
        {
          type: "pied",
          ligne: "",
          duree: 2,
          depart: "Porte des Lilas",
          arrivee: "ecole",
        },
      ],
    },
  },
  {
    name: "Yacine",
    type: "des",
    top: [14, 4, 6],
    entreprise: {
      arrivee: "09h45",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 13,
          depart: "maison",
          arrivee: "Boussy-Saint-Antoine",
        },
        {
          type: "rer",
          ligne: "D",
          duree: 40,
          depart: "Boussy-Saint-Antoine",
          arrivee: "Gare de Lyon",
        },
        {
          type: "rer",
          ligne: "A",
          duree: 10,
          depart: "Gare de Lyon",
          arrivee: "Charle de Gaules Etoile",
        },
        {
          type: "metro",
          ligne: "6",
          duree: 10,
          depart: "Charle de Gaules Etoile",
          arrivee: "Boissière",
        },
        {
          type: "pied",
          ligne: "",
          duree: 5,
          depart: "Boissière",
          arrivee: "entreprise",
        },
      ],
    },
    ecole: {
      arrivee: "09h15",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 13,
          depart: "maison",
          arrivee: "Boussy-Saint-Antoine",
        },
        {
          type: "rer",
          ligne: "D",
          duree: 40,
          depart: "Boussy-Saint-Antoine",
          arrivee: "Châtelet",
        },
        {
          type: "correspondance",
          ligne: "",
          duree: 6,
          depart: "Châtelet",
          arrivee: "Châtelet",
        },
        {
          type: "metro",
          ligne: "11",
          duree: 15,
          depart: "Châtelet",
          arrivee: "Porte des Lilas",
        },
        {
          type: "pied",
          ligne: "",
          duree: 2,
          depart: "Porte des Lilas",
          arrivee: "ecole",
        },
      ],
    },
  },
  {
    name: "Sohel",
    type: "des",
    top: [11, 1, 7],
    entreprise: {
      arrivee: "09h45",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 5,
          depart: "maison",
          arrivee: "Rougemeont Chanteloup",
        },
        {
          type: "tram",
          ligne: "T4",
          duree: 5,
          depart: "Rougemeont Chanteloup",
          arrivee: "Aulnay sous Bois",
        },
        {
          type: "rer",
          ligne: "B",
          duree: 21,
          depart: "Aulnay sous bois",
          arrivee: "Châtelet",
        },
        {
          type: "pied",
          ligne: "",
          duree: 6,
          depart: "Châtelet",
          arrivee: "entreprise",
        },
      ],
    },
    ecole: {
      arrivee: "09h00",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 5,
          depart: "maison",
          arrivee: "Rougemeont Chanteloup",
        },
        {
          type: "tram",
          ligne: "T4",
          duree: 5,
          depart: "Rougemeont Chanteloup",
          arrivee: "Aulnay sous Bois",
        },
        {
          type: "rer",
          ligne: "B",
          duree: 21,
          depart: "Aulnay sous bois",
          arrivee: "Châtelet",
        },
        {
          type: "correspondance",
          ligne: "",
          duree: 6,
          depart: "Châtelet",
          arrivee: "Châtelet",
        },
        {
          type: "metro",
          ligne: "11",
          duree: 22,
          depart: "Châtelet",
          arrivee: "Porte des Lilas",
        },
        {
          type: "pied",
          ligne: "",
          duree: 2,
          depart: "Porte des Lilas",
          arrivee: "ecole",
        },
      ],
    },
  },
  {
    name: "Ayoub",
    type: "des",
    top: [14],
    entreprise: {
      arrivee: "10h20",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 10,
          depart: "maison",
          arrivee: "Sartrouville",
        },
        {
          type: "rer",
          ligne: "A",
          duree: 20,
          depart: "Sartrouville",
          arrivee: "Auber",
        },
        {
          type: "metro",
          ligne: "8",
          duree: 5,
          depart: "Auber",
          arrivee: "Bonne Nouvelle",
        },
        {
          type: "pied",
          ligne: "",
          duree: 5,
          depart: "Bonne Nouvelle",
          arrivee: "entreprise",
        },
      ],
    },
    ecole: {
      arrivee: "09h15",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 10,
          depart: "maison",
          arrivee: "Sartrouville",
        },
        {
          type: "rer",
          ligne: "A",
          duree: 22,
          depart: "Sartrouville",
          arrivee: "Châtelet",
        },
        {
          type: "correspondance",
          ligne: "",
          duree: 6,
          depart: "Châtelet",
          arrivee: "Châtelet",
        },
        {
          type: "metro",
          ligne: "11",
          duree: 15,
          depart: "Châtelet",
          arrivee: "Porte des Lilas",
        },
        {
          type: "pied",
          ligne: "",
          duree: 2,
          depart: "Porte des Lilas",
          arrivee: "ecole",
        },
      ],
    },
  },
  {
    name: "Ludwig",
    type: "des",
    top: [14, 4, 5],
    entreprise: {
      arrivee: "09h30",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 10,
          depart: "maison",
          arrivee: "Bibliothèque François Mitterrand",
        },
        {
          type: "metro",
          ligne: "14",
          duree: 10,
          depart: "Bibliothèque François Mitterrand",
          arrivee: "Pyramides",
        },
        {
          type: "metro",
          ligne: "7",
          duree: 20,
          depart: "Pyramides",
          arrivee: "Corentin Cailloux",
        },
        {
          type: "pied",
          ligne: "",
          duree: 10,
          depart: "Corentin Cailloux",
          arrivee: "entreprise",
        },
      ],
    },
    ecole: {
      arrivee: "09h00",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 10,
          depart: "maison",
          arrivee: "Bibliothèque François Mitterrand",
        },
        {
          type: "metro",
          ligne: "14",
          duree: 10,
          depart: "Bibliothèque François Mitterrand",
          arrivee: "Châtelet",
        },
        {
          type: "metro",
          ligne: "11",
          duree: 20,
          depart: "Châtelet",
          arrivee: "Porte des Lilas",
        },
        {
          type: "pied",
          ligne: "",
          duree: 2,
          depart: "Porte des Lilas",
          arrivee: "ecole",
        },
      ],
    },
  },
  {
    name: "Ange",
    type: "des",
    top: [14, 9, 6],
    entreprise: {
      arrivee: "09h25",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 5,
          depart: "maison",
          arrivee: "Angélique Compoint",
        },
        {
          type: "bus",
          ligne: "341",
          duree: 9,
          depart: "Angélique Compoint",
          arrivee: "Saint-Ouen",
        },
        {
          type: "rer",
          ligne: "C",
          duree: 3,
          depart: "Saint-Ouen",
          arrivee: "Les Grésillons",
        },
        {
          type: "pied",
          ligne: "",
          duree: 7,
          depart: "Les Grésillons",
          arrivee: "entreprise",
        },
      ],
    },
    ecole: {
      arrivee: "09h30",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 5,
          depart: "maison",
          arrivee: "Angélique Compoint",
        },
        {
          type: "tram",
          ligne: "T3b",
          duree: 28,
          depart: "Angélique Compoint",
          arrivee: "Porte des Lilas",
        },
        {
          type: "pied",
          ligne: "",
          duree: 2,
          depart: "Porte des Lilas",
          arrivee: "ecole",
        },
      ],
    },
  },
  {
    name: "Justin",
    type: "dev",
    top: [14, 4, 1],
    entreprise: {
      arrivee: "09h00",
      trajet: [
        {
          type: "teletravail",
          ligne: "",
          duree: 1,
          depart: "maison",
          arrivee: "maison",
        },
      ],
    },
    ecole: {
      arrivee: "09h00",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 20,
          depart: "maison",
          arrivee: "Mairie des Lilas",
        },
        {
          type: "metro",
          ligne: "11",
          duree: 2,
          depart: "Mairie des Lilas",
          arrivee: "Porte des Lilas",
        },
        {
          type: "pied",
          ligne: "",
          duree: 2,
          depart: "Porte des Lilas",
          arrivee: "ecole",
        },
      ],
    },
  },
  {
    name: "Marie",
    type: "des",
    top: [2, 3, 4],
    entreprise: {
      arrivee: "09h00",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 7,
          depart: "maison",
          arrivee: "Porte de Bagnolet",
        },
        {
          type: "metro",
          ligne: "3",
          duree: 22,
          depart: "Porte de Bagnolet",
          arrivee: "Villiers",
        },
        {
          type: "metro",
          ligne: "2",
          duree: 3,
          depart: "Villiers",
          arrivee: "Courcelles",
        },
        {
          type: "pied",
          ligne: "",
          duree: 3,
          depart: "Courcelles",
          arrivee: "entreprise",
        },
      ],
    },
    ecole: {
      arrivee: "09h10",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 15,
          depart: "maison",
          arrivee: "ecole",
        },
      ],
    },
  },
  {
    name: "Alex",
    type: "dev",
    top: [5, 6, 1],
    entreprise: {
      arrivee: "10h10",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 5,
          depart: "maison",
          arrivee: "Laumière",
        },
        {
          type: "metro",
          ligne: "5",
          duree: 10,
          depart: "Laumière",
          arrivee: "République",
        },
        {
          type: "pied",
          ligne: "",
          duree: 5,
          depart: "République",
          arrivee: "entreprise",
        },
      ],
    },
    ecole: {
      arrivee: "09h00",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 30,
          depart: "maison",
          arrivee: "ecole",
        },
      ],
    },
  },
  {
    name: "Léonie",
    type: "dev",
    top: [14, 1, 4],
    entreprise: {
      arrivee: "10h10",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 5,
          depart: "maison",
          arrivee: "Rue Saint Maur",
        },
        {
          type: "metro",
          ligne: "3",
          duree: 2,
          depart: "Rue Saint Maur",
          arrivee: "République",
        },
        {
          type: "metro",
          ligne: "5",
          duree: 5,
          depart: "République",
          arrivee: "Gare du Nord",
        },
        {
          type: "pied",
          ligne: "",
          duree: 5,
          depart: "Gare du Nord",
          arrivee: "entreprise",
        },
      ],
    },
    ecole: {
      arrivee: "09h10",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 5,
          depart: "maison",
          arrivee: "Rue saint Maur",
        },
        {
          type: "metro",
          ligne: "3",
          duree: 4,
          depart: "Rue Saint Maur",
          arrivee: "Gambetta",
        },
        {
          type: "metro",
          ligne: "11",
          duree: 4,
          depart: "Gambetta",
          arrivee: "Porte des lilas",
        },
        {
          type: "pied",
          ligne: "",
          duree: 2,
          depart: "Porte des lilas",
          arrivee: "ecole",
        },
      ],
    },
  },
  {
    name: "Loris",
    type: "dev",
    top: ["3bis", 3, 14],
    entreprise: {
      arrivee: "09h00",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 5,
          depart: "maison",
          arrivee: "Porte de Bagnolet",
        },
        {
          type: "metro",
          ligne: "3",
          duree: 10,
          depart: "Porte de Bagnolet",
          arrivee: "Arts et Métiers",
        },
        {
          type: "pied",
          ligne: "",
          duree: 4,
          depart: "Arts et Métiers",
          arrivee: "travail",
        },
      ],
    },
    ecole: {
      arrivee: "09h05",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 6,
          depart: "maison",
          arrivee: "Gambetta",
        },
        {
          type: "metro",
          ligne: "3bis",
          duree: 3,
          depart: "Gambetta",
          arrivee: "Porte des lilas",
        },
        {
          type: "pied",
          ligne: "",
          duree: 2,
          depart: "Porte des lilas",
          arrivee: "ecole",
        },
      ],
    },
  },
  {
    name: "Ulysse",
    type: "dev",
    top: [4, 1, 14],
    entreprise: {
      arrivee: "09h00",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 13,
          depart: "maison",
          arrivee: "Vincennes",
        },
        {
          type: "rer",
          ligne: "A",
          duree: 11,
          depart: "Vincennes",
          arrivee: "Auber",
        },
        {
          type: "correspondance",
          ligne: "",
          duree: 5,
          depart: "Auber",
          arrivee: "Opéra",
        },
        {
          type: "metro",
          ligne: "3",
          duree: 8,
          depart: "Opéra",
          arrivee: "Pereire",
        },
        {
          type: "pied",
          ligne: "",
          duree: 3,
          depart: "Pereire",
          arrivee: "entreprise",
        },
      ],
    },
    ecole: {
      arrivee: "09h00",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 10,
          depart: "maison",
          arrivee: "Robespierre",
        },
        {
          type: "metro",
          ligne: "9",
          duree: 5,
          depart: "Robespierre",
          arrivee: "Porte de Montreuil",
        },
        {
          type: "tram",
          ligne: "T3b",
          duree: 9,
          depart: "Porte de Montreuil",
          arrivee: "Porte des Lilas",
        },
        {
          type: "pied",
          ligne: "",
          duree: 2,
          depart: "Porte des Lilas",
          arrivee: "ecole",
        },
      ],
    },
  },
  {
    name: "Charles-Antoine",
    type: "dev",
    top: [14, 4, 1],
    entreprise: {
      arrivee: "10h00",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 5,
          depart: "maison",
          arrivee: "Mairie de Montrouge",
        },
        {
          type: "metro",
          ligne: "4",
          duree: 21,
          depart: "Mairie de Montrouge",
          arrivee: "Strasbourg Saint Denis",
        },
        {
          type: "pied",
          ligne: "",
          duree: 4,
          depart: "Strasbourg Saint Denis",
          arrivee: "entreprise",
        },
      ],
    },
    ecole: {
      arrivee: "08h50",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 5,
          depart: "maison",
          arrivee: "Mairie de Montrouge",
        },
        {
          type: "metro",
          ligne: "4",
          duree: 16,
          depart: "Mairie de Montrouge",
          arrivee: "Châtelet",
        },
        {
          type: "metro",
          ligne: "11",
          duree: 13,
          depart: "Châtelet",
          arrivee: "Porte des Lilas",
        },
        {
          type: "pied",
          ligne: "",
          duree: 2,
          depart: "Porte des Lilas",
          arrivee: "ecole",
        },
      ],
    },
  },
  {
    name: "Maëlle",
    type: "dev",
    top: [11, 2, 9],
    entreprise: {
      arrivee: "09h45",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 5,
          depart: "maison",
          arrivee: "entreprise",
        },
      ],
    },
    ecole: {
      arrivee: "09h05",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 7,
          depart: "maison",
          arrivee: "Belleville",
        },
        {
          type: "metro",
          ligne: "11",
          duree: 6,
          depart: "Belleville",
          arrivee: "Porte des Lilas",
        },
        {
          type: "pied",
          ligne: "",
          duree: 2,
          depart: "Porte des Lilas",
          arrivee: "ecole",
        },
      ],
    },
  },
  {
    name: "Thoma",
    type: "dev",
    top: [11, 4, 14],
    entreprise: {
      arrivee: "09h45",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 9,
          depart: "maison",
          arrivee: "Parmentier",
        },
        {
          type: "metro",
          ligne: "3",
          duree: 4,
          depart: "Parmentier",
          arrivee: "Réaumur Sabastopol",
        },
        {
          type: "metro",
          ligne: "4",
          duree: 7,
          depart: "Réaumur Sabastopol",
          arrivee: "Saint Germain des Prés",
        },
        {
          type: "pied",
          ligne: "",
          duree: 7,
          depart: "Saint Germain des Prés",
          arrivee: "entreprise",
        },
      ],
    },
    ecole: {
      arrivee: "09h00",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 6,
          depart: "maison",
          arrivee: "Belleville",
        },
        {
          type: "metro",
          ligne: "11",
          duree: 6,
          depart: "Belleville",
          arrivee: "Porte des Lilas",
        },
        {
          type: "pied",
          ligne: "",
          duree: 2,
          depart: "Porte des Lilas",
          arrivee: "ecole",
        },
      ],
    },
  },
  {
    name: "Quentin S.",
    type: "des",
    top: [14, 9, 3],
    entreprise: {
      arrivee: "08h50",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 2,
          depart: "maison",
          arrivee: "Mairie des Lilas",
        },
        {
          type: "metro",
          ligne: "11",
          duree: 9,
          depart: "Mairie des Lilas",
          arrivee: "République",
        },
        {
          type: "metro",
          ligne: "3",
          duree: 3,
          depart: "République",
          arrivee: "Bonne Nouvelle",
        },
        {
          type: "pied",
          ligne: "",
          duree: 1,
          depart: "Bonne Nouvelle",
          arrivee: "entreprise",
        },
      ],
    },
    ecole: {
      arrivee: "09h00",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 2,
          depart: "maison",
          arrivee: "Mairie des Lilas",
        },
        {
          type: "metro",
          ligne: "11",
          duree: 2,
          depart: "Mairie des Lilas",
          arrivee: "Porte des Lilas",
        },
        {
          type: "pied",
          ligne: "",
          duree: 2,
          depart: "Porte des Lilas",
          arrivee: "ecole",
        },
      ],
    },
  },
  {
    name: "Pierre",
    type: "dev",
    top: [11, 1, 7],
    entreprise: {
      arrivee: "10h00",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 5,
          depart: "maison",
          arrivee: "Télégraphe",
        },
        {
          type: "metro",
          ligne: "11",
          duree: 7,
          depart: "Télégraphe",
          arrivee: "République",
        },
        {
          type: "pied",
          ligne: "",
          duree: 10,
          depart: "République",
          arrivee: "entreprise",
        },
      ],
    },
    ecole: {
      arrivee: "09h00",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 6,
          depart: "maison",
          arrivee: "ecole",
        },
      ],
    },
  },
  {
    name: "Bartholomé",
    type: "des",
    top: [5, 6, 1],
    entreprise: {
      arrivee: "10h00",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 15,
          depart: "maison",
          arrivee: "entreprise",
        },
      ],
    },
    ecole: {
      arrivee: "09h30",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 15,
          depart: "maison",
          arrivee: "Suresnes Longchamps",
        },
        {
          type: "tram",
          ligne: "T2",
          duree: 7,
          depart: "Suresnes Longchamps",
          arrivee: "La Défense",
        },
        {
          type: "metro",
          ligne: "1",
          duree: 20,
          depart: "La Défense",
          arrivee: "Hôtel de ville",
        },
        {
          type: "metro",
          ligne: "11",
          duree: 20,
          depart: "Hôtel de ville",
          arrivee: "Porte des Lilas",
        },
        {
          type: "pied",
          ligne: "",
          duree: 2,
          depart: "Porte des Lilas",
          arrivee: "ecole",
        },
      ],
    },
  },
  {
    name: "Antoine T.",
    type: "dev",
    top: [8, 7],
    entreprise: {
      arrivee: "10h00",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 13,
          depart: "maison",
          arrivee: "entreprise",
        },
      ],
    },
    ecole: {
      arrivee: "09h06",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 3,
          depart: "maison",
          arrivee: "Gambetta Ivry",
        },
        {
          type: "bus",
          ligne: "180",
          duree: 8,
          depart: "Gambetta Ivry",
          arrivee: "Liberté",
        },
        {
          type: "metro",
          ligne: "8",
          duree: 16,
          depart: "Liberté",
          arrivee: "République",
        },
        {
          type: "metro",
          ligne: "11",
          duree: 8,
          depart: "République",
          arrivee: "Porte des Lilas",
        },
        {
          type: "pied",
          ligne: "",
          duree: 2,
          depart: "Porte des Lilas",
          arrivee: "ecole",
        },
      ],
    },
  },
  {
    name: "Enzo",
    type: "dev",
    top: [6, 1, 14],
    entreprise: {
      arrivee: "09h45",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 5,
          depart: "maison",
          arrivee: "Charles de Gaulle Etoile",
        },
        {
          type: "metro",
          ligne: "2",
          duree: 13,
          depart: "Charles de Gaulle Etoile",
          arrivee: "Barbès Rochechouart",
        },
        {
          type: "pied",
          ligne: "",
          duree: 2,
          depart: "Barbès Rochechouart",
          arrivee: "entreprise",
        },
      ],
    },
    ecole: {
      arrivee: "08h50",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 5,
          depart: "maison",
          arrivee: "Georges V",
        },
        {
          type: "metro",
          ligne: "1",
          duree: 11,
          depart: "Georges V",
          arrivee: "Hôtel de ville",
        },
        {
          type: "metro",
          ligne: "11",
          duree: 12,
          depart: "Hôtel de ville",
          arrivee: "Porte des Lilas",
        },
        {
          type: "pied",
          ligne: "",
          duree: 2,
          depart: "Porte des Lilas",
          arrivee: "ecole",
        },
      ],
    },
  },
  {
    name: "Sally",
    type: "des",
    top: [4, 1, 14],
    entreprise: {
      arrivee: "10h00",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 7,
          depart: "maison",
          arrivee: "Saint Germain Des Prés",
        },
        {
          type: "metro",
          ligne: "4",
          duree: 11,
          depart: "Saint Germain Des Prés",
          arrivee: "Gare de l'Est",
        },
        {
          type: "metro",
          ligne: "5",
          duree: 6,
          depart: "Gare de l'Est",
          arrivee: "Richard Lenoir",
        },
        {
          type: "pied",
          ligne: "",
          duree: 4,
          depart: "Richard Lenoir",
          arrivee: "entreprise",
        },
      ],
    },
    ecole: {
      arrivee: "09h00",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 7,
          depart: "maison",
          arrivee: "Saint Germain Des Prés",
        },
        {
          type: "metro",
          ligne: "4",
          duree: 5,
          depart: "Saint Germain Des Prés",
          arrivee: "Châtelet",
        },
        {
          type: "metro",
          ligne: "11",
          duree: 13,
          depart: "Châtelet",
          arrivee: "Porte des Lilas",
        },
        {
          type: "pied",
          ligne: "",
          duree: 2,
          depart: "Porte des Lilas",
          arrivee: "ecole",
        },
      ],
    },
  },
  {
    name: "Danut",
    type: "des",
    top: [5, 11, 4],
    entreprise: {
      arrivee: "11h15",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 7,
          depart: "maison",
          arrivee: "Le Blanc Mesnil",
        },
        {
          type: "rer",
          ligne: "B",
          duree: 19,
          depart: "Le Blanc Mesnil",
          arrivee: "Châtelet",
        },
        {
          type: "metro",
          ligne: "7",
          duree: 20,
          depart: "Châtelet",
          arrivee: "Villejuif",
        },
        {
          type: "pied",
          ligne: "",
          duree: 10,
          depart: "Villejuif",
          arrivee: "entreprise",
        },
      ],
    },
    ecole: {
      arrivee: "09h10",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 7,
          depart: "maison",
          arrivee: "Le Blanc Mesnil",
        },
        {
          type: "rer",
          ligne: "B",
          duree: 19,
          depart: "Le Blanc Mesnil",
          arrivee: "Châtelet",
        },
        {
          type: "correspondance",
          ligne: "",
          duree: 6,
          depart: "Châtelet",
          arrivee: "Châtelet",
        },
        {
          type: "metro",
          ligne: "11",
          duree: 13,
          depart: "Châtelet",
          arrivee: "Porte des Lilas",
        },
        {
          type: "pied",
          ligne: "",
          duree: 2,
          depart: "Porte des Lilas",
          arrivee: "ecole",
        },
      ],
    },
  },
  {
    name: "Simon",
    type: "des",
    top: [14, 3, 1],
    entreprise: {
      arrivee: "09h30",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 3,
          depart: "maison",
          arrivee: "Jourdain",
        },
        {
          type: "metro",
          ligne: "11",
          duree: 2,
          depart: "Jourdain",
          arrivee: "Belleville",
        },
        {
          type: "metro",
          ligne: "2",
          duree: 5,
          depart: "Belleville",
          arrivee: "La Chapelle",
        },
        {
          type: "correspondance",
          ligne: "",
          duree: 7,
          depart: "La Chapelle",
          arrivee: "Paris Nord",
        },
        {
          type: "rer",
          ligne: "B",
          duree: 26,
          depart: "Paris Nord",
          arrivee: "Aéroport Charles de Gaulle 1",
        },
        {
          type: "pied",
          ligne: "",
          duree: 5,
          depart: "Aéroport Charles de Gaulle 1",
          arrivee: "entreprise",
        },
      ],
    },
    ecole: {
      arrivee: "09h00",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 3,
          depart: "maison",
          arrivee: "Jourdain",
        },
        {
          type: "metro",
          ligne: "11",
          duree: 3,
          depart: "Jourdain",
          arrivee: "Porte des Lilas",
        },
        {
          type: "pied",
          ligne: "",
          duree: 2,
          depart: "Porte des Lilas",
          arrivee: "ecole",
        },
      ],
    },
  },
  {
    name: "Anna",
    type: "des",
    top: [4, 1, 11],
    entreprise: {
      arrivee: "09h45",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 7,
          depart: "maison",
          arrivee: "Hôtel de Ville",
        },
        {
          type: "metro",
          ligne: "11",
          duree: 3,
          depart: "Hôtel de Ville",
          arrivee: "République",
        },
        {
          type: "metro",
          ligne: "5",
          duree: 12,
          depart: "République",
          arrivee: "Porte de Pantin",
        },
        {
          type: "pied",
          ligne: "",
          duree: 10,
          depart: "Porte de Pantin",
          arrivee: "entreprise",
        },
      ],
    },
    ecole: {
      arrivee: "09h00",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 7,
          depart: "maison",
          arrivee: "Hôtel de Ville",
        },
        {
          type: "metro",
          ligne: "11",
          duree: 12,
          depart: "Hôtel de Ville",
          arrivee: "Porte des Lilas",
        },
        {
          type: "pied",
          ligne: "",
          duree: 2,
          depart: "Porte des Lilas",
          arrivee: "ecole",
        },
      ],
    },
  },
  {
    name: "Camille",
    type: "des",
    top: [14, 1, 9],
    entreprise: {
      arrivee: "09h35",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 8,
          depart: "maison",
          arrivee: "Hôpital Européen Georges Pompidou",
        },
        {
          type: "bus",
          ligne: "169",
          duree: 6,
          depart: "Hôpital Européen Georges Pompidou",
          arrivee: "Victor Hugo",
        },
        {
          type: "correspondance",
          ligne: "",
          duree: 3,
          depart: "Victor Hugo",
          arrivee: "Porte de Saint-Cloud",
        },
        {
          type: "bus",
          ligne: "189",
          duree: 8,
          depart: "Porte de Saint-Cloud",
          arrivee: "Le Jour Se Lève",
        },
        {
          type: "pied",
          ligne: "",
          duree: 2,
          depart: "Le Jour Se Lève",
          arrivee: "entreprise",
        },
      ],
    },
    ecole: {
      arrivee: "09h00",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 16,
          depart: "maison",
          arrivee: "Mairie d'Issy",
        },
        {
          type: "metro",
          ligne: "12",
          duree: 11,
          depart: "Mairie d'Issy",
          arrivee: "Montparnasse Bienvenüe",
        },
        {
          type: "metro",
          ligne: "4",
          duree: 8,
          depart: "Montparnasse Bienvenüe",
          arrivee: "Châtelet",
        },
        {
          type: "metro",
          ligne: "11",
          duree: 13,
          depart: "Châtelet",
          arrivee: "Porte des Lilas",
        },
        {
          type: "pied",
          ligne: "",
          duree: 2,
          depart: "Porte des Lilas",
          arrivee: "ecole",
        },
      ],
    },
  },
  {
    name: "Ambroise",
    type: "des",
    top: [14, 1, 11],
    entreprise: {
      arrivee: "11h00",
      trajet: [
        {
          type: "velo",
          ligne: "",
          duree: 40,
          depart: "maison",
          arrivee: "entreprise",
        },
      ],
    },
    ecole: {
      arrivee: "09h40",
      trajet: [
        {
          type: "velo",
          ligne: "",
          duree: 25,
          depart: "maison",
          arrivee: "ecole",
        },
      ],
    },
  },
  {
    name: "Pierre-Andréas",
    type: "des",
    top: [14, 1],
    entreprise: {
      arrivee: "09h00",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 5,
          depart: "maison",
          arrivee: "Porte des Lilas",
        },
        {
          type: "metro",
          ligne: "11",
          duree: 9,
          depart: "Porte des Lilas",
          arrivee: "République",
        },
        {
          type: "metro",
          ligne: "9",
          duree: 3,
          depart: "République",
          arrivee: "Bonne Nouvelle",
        },
        {
          type: "pied",
          ligne: "",
          duree: 3,
          depart: "Bonne Nounvelle",
          arrivee: "entreprise",
        },
      ],
    },
    ecole: {
      arrivee: "09h00",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 5,
          depart: "maison",
          arrivee: "ecole",
        },
      ],
    },
  },
  {
    name: "Jessica",
    type: "des",
    top: [14, 1, 4],
    entreprise: {
      arrivee: "09h10",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 5,
          depart: "maison",
          arrivee: "Bibliothèque Francois Mitterrand",
        },
        {
          type: "metro",
          ligne: "14",
          duree: 5,
          depart: "Bibliothèque Francois Mitterrand",
          arrivee: "Gare de Lyon",
        },
        {
          type: "rer",
          ligne: "D",
          duree: 12,
          depart: "Gare de Lyon",
          arrivee: "Stade de France Saint Denis",
        },
        {
          type: "pied",
          ligne: "",
          duree: 9,
          depart: "Stade de France Saint Denis",
          arrivee: "entreprise",
        },
      ],
    },
    ecole: {
      arrivee: "09h00",
      trajet: [
        {
          type: "pied",
          ligne: "",
          duree: 5,
          depart: "maison",
          arrivee: "Bibliothèque Francois Mitterrand",
        },
        {
          type: "metro",
          ligne: "14",
          duree: 9,
          depart: "Bibliothèque Francois Mitterrand",
          arrivee: "Châtelet",
        },
        {
          type: "metro",
          ligne: "11",
          duree: 13,
          depart: "Châtelet",
          arrivee: "Porte des Lilas",
        },
        {
          type: "pied",
          ligne: "",
          duree: 2,
          depart: "Porte des Lilas",
          arrivee: "ecole",
        },
      ],
    },
  },
  {
    name: "Sami",
    type: "des",
    top: [14, 1, 12],
    entreprise: {
      arrivee: "09h00",
      trajet: [
        {
          type: "trottinette",
          ligne: "",
          duree: 10,
          depart: "maison",
          arrivee: "entreprise",
        },
      ],
    },
    ecole: {
      arrivee: "09h00",
      trajet: [
        {
          type: "trottinette",
          ligne: "",
          duree: 10,
          depart: "maison",
          arrivee: "entreprise",
        },
      ],
    },
  },
];
